import { render, staticRenderFns } from "./KETTrainerschluessel.vue?vue&type=template&id=caf9edc2&"
import script from "./KETTrainerschluessel.vue?vue&type=script&lang=js&"
export * from "./KETTrainerschluessel.vue?vue&type=script&lang=js&"
import style0 from "./KETTrainerschluessel.vue?vue&type=style&index=0&id=caf9edc2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports